function getLabelText(value, labelKey) {
  if (value === null || typeof value === 'undefined') {
    return null;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }
  if (!labelKey || typeof value !== 'object') {
    return null;
  }
  const resolvedValue = value[labelKey];
  if (typeof resolvedValue === 'string' || typeof resolvedValue === 'number') {
    return String(resolvedValue);
  }
  return null;
}
function isPlainLabelList(items, getLabel) {
  if (!Array.isArray(items) || items.length === 0) {
    return false;
  }
  return items.every(item => getLabel(item) !== null);
}
function isPlainLabelTree(items, getLabel, getChildren) {
  if (!Array.isArray(items) || items.length === 0) {
    return false;
  }
  return items.every(item => {
    const children = getChildren(item);
    return getLabel(item) !== null && (!(children === null || children === void 0 ? void 0 : children.length) || isPlainLabelTree(children, getLabel, getChildren));
  });
}

export { getLabelText, isPlainLabelList, isPlainLabelTree };
